import React, { useContext } from 'react'

import { useI18n } from '@shopify/react-i18n'
import { Tooltip } from '@vividseats/vivid-ui-kit'

import FilterContext from '@/components/pages/production/components/context'
import ListingsContext from '@/context/listings/context'
import MapContext from '@/context/map'
import { usePromoPrice } from '@/hooks/use-promo-price'
import { getFormattedCurrency } from '@/utils/i18n'

import styles from './styles.module.scss'

export type MapTooltipProps = {
    price: number
    x: number
    y: number
}

const MapTooltip = ({ x, y, price }: MapTooltipProps) => {
    const {
        state: {
            quantityFilterState: { quantity: filterQuantity },
        },
    } = useContext(FilterContext)

    const {
        selectors: { lowestPricedListingInSection },
    } = useContext(MapContext)

    const {
        selectors: { i18nListingsData },
    } = useContext(ListingsContext)

    const [i18n] = useI18n()

    const quantity = filterQuantity || lowestPricedListingInSection?.defaultQuantity || 1

    const promoPrice = usePromoPrice(Number(price), quantity)
    const finalPrice = !promoPrice ? price : promoPrice

    const currency = i18nListingsData?.applyCurrencyConversion ? i18nListingsData.to : undefined
    const precision = !!currency || Number.isSafeInteger(finalPrice) ? 0 : 2
    const priceToFormat = precision === 0 ? Math.ceil(finalPrice) : finalPrice
    const shownPrice = getFormattedCurrency(
        i18n,
        priceToFormat,
        currency,
        i18nListingsData?.applyCurrencyConversion,
        precision,
    )

    return (
        <div className={styles.tooltipWrapper}>
            <Tooltip show={price > 0} x={x} y={y}>
                <span className={styles.tooltipContent} data-testid="map-tooltip-price">
                    from <strong> {shownPrice} </strong>
                </span>
            </Tooltip>
        </div>
    )
}

export default MapTooltip
